import { API } from "@/lib/api";
import { APIService } from "@/services/api";
import { ReadSystemRole, WriteSystemRole } from "@/types/systemRole";

export const SystemRolesService = new APIService<
  ReadSystemRole,
  WriteSystemRole
>(API.SystemRoles);

export const fetchSystemRoles = SystemRolesService.getStaticList;
export const fetchSystemRoleList = SystemRolesService.getList;
